import { useContext } from 'react'
import { LoadingSpinner } from './Primitives'
import DhtnLogo from './DhtnLogo'
import { I18nContext } from '../../i18n/I18nContext'
import { authCopy } from '../../i18n/authCopy'

export function LoadingScreen({ message }: { message?: string }) {
    const i18n = useContext(I18nContext)
    const documentLanguage = typeof document === 'undefined' ? 'en' : document.documentElement.lang
    const language = i18n?.language ?? (documentLanguage === 'ar' || documentLanguage === 'ha' ? documentLanguage : 'en')
    const label = message || authCopy[language].loading
    // The mark with its Shine looping (founder, 10 Oct 2026; it replaces the 7 Oct spinner): no "Loading"
    // text on screen; screen readers still hear the label.
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[var(--dhtn-canvas)] text-[var(--dhtn-text-muted)]" role="status" aria-label={label}>
            <DhtnLogo variant="symbol" shine="loop" className="h-[72px]" />
        </div>
    )
}

export function LoadingOverlay() {
    return <div className="flex items-center justify-center py-16"><LoadingSpinner size="lg" color="text" /></div>
}

export default LoadingScreen
